function Input({
  boxSizing,
  padding,
  textAlign,
  height,
  marginRight,
  width,
  placeholder,
  value,
  onChange,
  disabled = false,
}) {
  return (
    <input
      style={{
        color: "var(--cor-preto)",
        backgroundColor: "var(--cor-branco)",
        border: "1px solid var(--cor-cinzaMargin)",
        marginTop: 5,
        fontSize: 20,
        marginRight: marginRight,
        borderRadius: 10,
        width: width,
        height: height,
        fontFamily: "Roboto",
        padding: padding,
        paddingLeft: 10,
        textAlign: textAlign,
        boxSizing: boxSizing,
      }}
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
}
export default Input;
